 

import { React, useState, useEffect } from "react";
import "../../components/DashboardModule/MyQuotations.css";
import { getSellerMyQuotation } from "../../API/Api";
import PendingQuotesDetails from "./PendingQuotesDetails";
import { MoreVertical } from "lucide-react";

const QuotationShared = () => {
    const [showDetails, setShowDetails] = useState(false);
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    useEffect(() => {
        const fetchEnquiries = async () => {
            try {
                const response = await getSellerMyQuotation();
                if (response.status && response.data) {
                    setEnquiries(response.data);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching enquiries:", error);
                setLoading(false);
            }
        };

        fetchEnquiries();
    }, []);

    const handleRejectClick = () => {
        
    };

    const handleOpenClick = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setShowDetails(true);
    };

    const handleBackClick = () => {
        setShowDetails(false);
    };

    if (showDetails && selectedEnquiry) {
        return (
            <PendingQuotesDetails
                onBack={handleBackClick}
                enquiry={selectedEnquiry}
                enquiryId={selectedEnquiry.enquiry_id}
            />
        );
    }

    return (
        <div className="quo-container font-poppins">
            <div className="quo-header">
                <h2 className="quo-title">My Shared Quotes</h2>
                <div className="quo-actions"></div>
            </div>

            <table className="quo-table">
                <thead>
                    <tr>
                        <th>RFQ ID</th>
                        <th>Product Details</th>
                        <th>Brand Name</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Action</th>

                    </tr>
                </thead>
                <tbody>
                    {enquiries.map((enquiry) => (
                        <tr key={enquiry.enquiry_id}>
                            <td>{enquiry.order_id}</td>
                            <td>
                                <div className="product-details">
                                    <div className="product-name">
                                        {enquiry.product_details.product_name}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {enquiry.brands && enquiry.brands.length > 0 ? (
                                    enquiry.brands.map((brand, index) => (
                                        <span key={brand.id}>
                                            {brand.name}
                                            {index < enquiry.brands.length - 1 && ", "}
                                        </span>
                                    ))
                                ) : (
                                    ""
                                )}
                            </td>
                            <td>
                                {new Date(enquiry.product_details.created_at).toLocaleDateString()}
                            </td>
                            <td>{enquiry.status}</td>
                            <td>
                                <div className="quo-action-menu">
                                    <MoreVertical />
                                    <div className="quo-dropdown">
                                        <button 
                                            className="text-quo font-poppins" 
                                            onClick={() => handleOpenClick(enquiry)}
                                        >
                                            Preview
                                        </button>
                                        <button 
                                            className="text-quo font-poppins"
                                            onClick={() => handleRejectClick(enquiry.enquiry_id)}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* <div className="quo-bottom-actions">
                {enquiries.length > 0 && (
                    <button
                        className="quo-accept font-poppins"
                        onClick={() => handleOpenClick(enquiries[0])} // You can make this dynamic later
                    >
                        OPEN Details
                    </button>
                )}
                
            </div> */}
        </div>
    );
};

export default QuotationShared;



